import React, { useState } from 'react';
import { PhotoDisplayData } from '../../types/PhotoDisplayData';
import { PhotoAudience } from '../../types';
import { useSeasonsStore } from '../../stores/useSeasonsStore';
import { useUIStore } from '../../stores/useUIStore';
import { BaseInlineActions } from './BaseInlineActions';
import './InlinePhotoAudienceToggle.css';

const NEXT_AUDIENCE: Record<PhotoAudience, PhotoAudience> = { PERSONAL: 'FAMILY', FAMILY: 'PERSONAL' };

const AUDIENCE_PRESENTATION: Record<PhotoAudience, { glyph: string; label: string }> = {
  FAMILY: { glyph: '👨‍👩‍👧', label: 'Shown to family. Click to hide from family.' },
  PERSONAL: { glyph: '🔒', label: 'Personal only. Click to show to family.' }
};

interface InlinePhotoAudienceToggleProps {
  photo: PhotoDisplayData;
}

export const InlinePhotoAudienceToggle: React.FC<InlinePhotoAudienceToggleProps> = ({ photo }) => {
  const updatePhoto = useSeasonsStore(s => s.updatePhoto);
  const showToast = useUIStore(s => s.showToast);
  const [isPending, setIsPending] = useState(false);
  const { glyph, label } = AUDIENCE_PRESENTATION[photo.audience];

  const handleToggle = async () => {
    if (isPending) {
      return;
    }
    setIsPending(true);
    try {
      await updatePhoto(photo.id, { audience: NEXT_AUDIENCE[photo.audience] });
    } catch {
      showToast('Failed to update photo audience', 'error');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <BaseInlineActions
      className="inline-photo-audience-toggle"
      onClick={handleToggle}
      title={label}
      ariaLabel={label}
      pressed={photo.audience === 'FAMILY'}
      disabled={isPending}
      data-testid="photo-audience-toggle"
    >
      {glyph}
    </BaseInlineActions>
  );
};
